<template>
  <div class="no-freeze-spinner" :class="isCompLoader ? 'comp-loader' : ''">
    <div id="no-freeze-spinner">
      <div>
        <i class="fa fa-envelope"></i>
        <i class="fa fa-list"></i>
        <i class="fa fa-user-tie"></i>
        <i class="fa fa-calculator"></i>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    isCompLoader: {
      type: Boolean,
    },
  },
};
</script>

<style>
@import "./../assets/css/loader.css";

#no-freeze-spinner > div > div {
  border: 5px solid var(--primary-color);
  animation-play-state: paused;
  border-radius: 50%;
  animation: rotate 1s infinite linear;
  border-left-color: rgba(200, 200, 200, 0.4);
}
.no-freeze-spinner #no-freeze-spinner i {
  color: var(--primary-color);
}
</style>